var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7197 7.8784C19.6275 7.51002 19.4397 7.1725 19.1753 6.89993C18.9109 6.62735 18.5793 6.42938 18.2139 6.326C16.8788 6 11.5386 6 11.5386 6C11.5386 6 6.19837 6 4.86332 6.35705C4.49792 6.46043 4.16627 6.6584 3.90188 6.93098C3.63748 7.20355 3.4497 7.54107 3.35749 7.90944C3.11316 9.26434 2.99364 10.6388 3.00044 12.0155C2.99173 13.4026 3.11126 14.7876 3.35749 16.1527C3.45914 16.5096 3.65113 16.8343 3.91492 17.0953C4.1787 17.3564 4.50535 17.545 4.86332 17.6429C6.19837 18 11.5386 18 11.5386 18C11.5386 18 16.8788 18 18.2139 17.6429C18.5793 17.5396 18.9109 17.3416 19.1753 17.069C19.4397 16.7965 19.6275 16.4589 19.7197 16.0906C19.9622 14.7459 20.0817 13.3819 20.0768 12.0155C20.0855 10.6284 19.966 9.24349 19.7197 7.8784Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79248 14.5537L14.2556 12.0155L9.79248 9.47736V14.5537Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.b5d3ff216d71f2e6527f40de79466c90.svg";
export { ForwardRef as ReactComponent };